module.exports = __webpack_public_path__ + "img/profile.86cab9d2.svg";